module.exports = new __parcel__URL__("city-1.1218dbad.png").toString();